/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_3_DInputs */

const en_tut_part_3_d = /** @type {(inputs: Tut_Part_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The space where the team is visibly present: a map, desks, nearby audio, shared focus, and guests. Entering the office turns on nobody's microphone or camera.`)
};

const id_tut_part_3_d = /** @type {(inputs: Tut_Part_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang tempat tim terlihat hadir: peta, meja, suara sekitar, fokus bersama, dan tamu. Masuk kantor tidak menyalakan mikrofon atau kamera siapa pun.`)
};

/**
* | output |
* | --- |
* | "The space where the team is visibly present: a map, desks, nearby audio, shared focus, and guests. Entering the office turns on nobody's microphone or camera." |
*
* @param {Tut_Part_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_3_d = /** @type {((inputs?: Tut_Part_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_3_d(inputs)
	return en_tut_part_3_d(inputs)
});